/**
 * 外壳的客户端状态。跨组件共享，按选型纪律用 Zustand；记在本机即可。
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ShellState {
  /** 回退测试用：临时切回旧侧栏布局。确认新外壳后连同旧布局一起删除 */
  legacy: boolean;
  paletteOpen: boolean;
  setLegacy: (legacy: boolean) => void;
  setPaletteOpen: (open: boolean) => void;
}

export const useShellStore = create<ShellState>()(
  persist(
    (set) => ({
      legacy: false,
      paletteOpen: false,
      setLegacy: (legacy) => set({ legacy }),
      setPaletteOpen: (paletteOpen) => set({ paletteOpen }),
    }),
    {
      name: 'shell.v2',
      partialize: (s) => ({ legacy: s.legacy }),
    },
  ),
);
